/* eslint-disable require-atomic-updates */
import { CONFIG } from "~/config";

interface ITrafficListBE {
	data: Array<Array<any>>;
	headers: Array<string>;
	totalCount: number;
}

interface ITrafficListItem {
	active: number;
	difeedbacknote: string;
	id: number;
	"last-update": string;
	maplist: number;
	name: string;
	no: number;
	"no-today": number;
	validity: {
		from: number;
		to: number;
	};
	yes: number;
}

interface ITrafficDetailItem {
	data: Array<{
		date: string;
		name: string;
		note: string;
		type: number;
	}>;
	sum: {
		yes: number;
		no: number;
		noToday: number;
	};
	totalCount: number;
}

interface ITrafficList {
	items: Array<ITrafficListItem>;
	totalCount: number;
}

interface ITrafficFeedbackData {
	lastListTimeout: number;
	lastListDate: number;
	lastListData: ITrafficList;
}

const ENDPOINT = "traffic-feedback";
const trafficFeedbackData: ITrafficFeedbackData = {
	// 15m
	lastListTimeout: 15 * 60 * 1000,
	lastListDate: 0,
	lastListData: null,
};

export async function getTrafficFeedbackList(): Promise<ITrafficList> {
	if (trafficFeedbackData.lastListDate + trafficFeedbackData.lastListTimeout < Date.now()) {
		try {
			const request = await fetch(`${CONFIG.requestUrl}/${ENDPOINT}/list`);
			const json = await request.json() as ITrafficListBE;
			const items = [];

			json.data.forEach(item => {
				const newItem = {};

				json.headers.forEach((header, ind) => {
					newItem[header] = item[ind];
				});

				items.push(newItem);
			});

			trafficFeedbackData.lastListData = {
				items,
				totalCount: json.totalCount,
			};
			trafficFeedbackData.lastListDate = Date.now();
		} catch (exc) {
			trafficFeedbackData.lastListData = null;
		}
	}

	return trafficFeedbackData.lastListData;
}

export async function getTrafficFeedbackDetail(id: number): Promise<ITrafficDetailItem> {
	try {
		const request = await fetch(`${CONFIG.requestUrl}/${ENDPOINT}/detail/${id}`);
		const json = await request.json();

		return json;
	} catch (exc) {
		//
	}

	return null;
}
